import { Routes } from '@angular/router';
import { EventDetailComponent } from './event-detail/event-detail.component';
import { EventsComponent } from './events/events.component';

export const routes: Routes = [
    {
        path: ':id',  // The :id is a dynamic route parameter
        component: EventDetailComponent
    },
    {
        path: '',  // The :id is a dynamic route parameter
        component: EventsComponent
    },
    { path: '**', redirectTo: '' }

];
